<template>
  <div>
    <p v-for="(error, index) in errors" :key="`${innerKey}-${index}`" class="red">
      {{ error }}
    </p>
  </div></template
>
<script>
export default {
  name: 'CompanyFieldErrors',
  props: ['errors', 'innerKey']
}
</script>
<style scoped>
.red {
  color: red;
}
</style>
